import { Command } from 'commands/Commands';

export class ChangeFontCommand extends Command {
	type: string = 'ChangeFontWeight';
	priority: number = 100;
}